import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

const DailyClaimSettings = () => {
  const [baseReward, setBaseReward] = useState();
  const [pointIncrement, setPointIncrement] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  
  const fetchAdvanceInfo = async () => {
    try {
      setLoading(true);
      const { data, error } = await apiCall("GET", "/get-advance-info");
      if (data) {
        console.log("Advance info data:", data);
        // Extract daily claim data from daily_claim object
        const dailyClaimData = data?.data?.daily_claim || {};
        const currentBaseReward = dailyClaimData?.baseReward || 0;
        const currentPointIncrement = dailyClaimData?.pointIncriment || 0;
        
        setBaseReward(currentBaseReward);
        setPointIncrement(currentPointIncrement);
        console.log("Current base reward:", currentBaseReward);
        console.log("Current point increment:", currentPointIncrement);
      }
    } catch (e) {
      console.log(e.message);
      toast.error("Failed to fetch advance info");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvanceInfo();
  }, []);

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const body = { 
        baseReward: baseReward,
        pointIncrement: pointIncrement 
      };
      console.log("Update body:", body);
      const {data, error} = await apiCall("POST", `/update-daily-claim`, body);
      if (error) {
        toast.error(error.message || "An error occurred");
      } else {
        toast.success(data.message || "Daily claim settings updated successfully!");
        fetchAdvanceInfo(); // Refresh the data after update
      }
    } catch (error) {
      console.log("error------", error);
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Daily Claim Settings</h2>
            <div className="input-group2">
              <label>Base Reward Value (First Day):</label>
              <input
                type="number"
                name="baseReward"
                placeholder="Enter Base Reward Value"
                value={baseReward || ""}
                onChange={(e) => setBaseReward(e.target.value)}
                disabled={loading}
                required
              />
            </div>
            <div className="input-group2">
              <label>Increment By:</label>
              <input
                type="number"
                name="pointIncrement"
                placeholder="Enter Increment Value"
                value={pointIncrement || ""}
                onChange={(e) => setPointIncrement(e.target.value)}
                disabled={loading}
                required
              />
            </div>
            {loading && <p>Loading...</p>}
            <div className="button-container">
              <Button 
                type="submit" 
                variant="primary" 
                onClick={handleUpdate}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Daily Claim Settings"}
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default DailyClaimSettings;